import BodyContentType from 'owa-service/lib/contract/BodyContentType';
import { trace } from 'owa-trace';

const IMG_BEGIN_REGEX = new RegExp('<img[\\s\\S]*?>|<image[\\s\\S]*?>', 'gim');
const IMG_END_REGEX = new RegExp('</img>|</image>', 'gim');
/**
 * Get body content in plain text format.
 * @param body
 */
const getTextBodyFromOriginalBody = (body: BodyContentType): string => {
    const text = body.Value;

    if (body.BodyType == 'Text') {
        return text;
    }
    // Replace <img> and <image> with [X] to keep it consistent with server side converter
    const textWithoutImages = text.replace(IMG_BEGIN_REGEX, '[X]').replace(IMG_END_REGEX, '');
    try {
        // parseFromString can throw exception in IE
        const doc = new DOMParser().parseFromString(textWithoutImages, 'text/html').documentElement;
        if (doc) {
            const scriptsAndStyles = doc.querySelectorAll('script,style');
            for (let i = 0; i < scriptsAndStyles.length; i++) {
                const node = scriptsAndStyles[i];
                if (node.parentNode) {
                    node.parentNode.removeChild(node);
                }
            }
            return doc.innerText || doc.textContent;
        }
        // throw error if doc does not exist
        throw new Error();
    } catch (e) {
        trace.error('SmimeTraceError: Could not parse mail body.');
        // TODO: Add appropriate infobar when mail could not be parsed. WI: #47732
        return '';
    }
};

export default getTextBodyFromOriginalBody;
